"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ComponentMetricsProvider", {
  enumerable: true,
  get: function get() {
    return _ComponentMetricsProvider.default;
  }
});
Object.defineProperty(exports, "GTMEventData", {
  enumerable: true,
  get: function get() {
    return _types.GTMEventData;
  }
});
Object.defineProperty(exports, "MetricsTracker", {
  enumerable: true,
  get: function get() {
    return _MetricsTracker.MetricsTracker;
  }
});
Object.defineProperty(exports, "MetricsTrackerType", {
  enumerable: true,
  get: function get() {
    return _types.MetricsTrackerType;
  }
});
Object.defineProperty(exports, "PageMetricsProvider", {
  enumerable: true,
  get: function get() {
    return _PageMetricsProvider.default;
  }
});
Object.defineProperty(exports, "SPARouteMetricsProvider", {
  enumerable: true,
  get: function get() {
    return _SPARouteMetricsProvider.default;
  }
});
Object.defineProperty(exports, "USER_EVENTS", {
  enumerable: true,
  get: function get() {
    return _enums.default;
  }
});
Object.defineProperty(exports, "generateMetricsAttribute", {
  enumerable: true,
  get: function get() {
    return _MetricsTracker.generateMetricsAttribute;
  }
});
var _MetricsTracker = require("./MetricsTracker");
var _PageMetricsProvider = _interopRequireDefault(require("./providers/PageMetricsProvider"));
var _ComponentMetricsProvider = _interopRequireDefault(require("./providers/ComponentMetricsProvider"));
var _SPARouteMetricsProvider = _interopRequireDefault(require("./providers/SPARouteMetricsProvider"));
var _enums = _interopRequireDefault(require("./types/enums"));
var _types = require("./types/types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//# sourceMappingURL=index.js.map